import React, { Component } from 'react'
import { connect } from 'shalala';
import { Row, Col } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

import { useStore } from '../../store';
import TimbradoMasivoTicketList from './tickets/TimbradoMasivoTicketList';
import TimbradoMasivoTicketsSearch from './tickets/components/TimbradoMasivoTicketsSearch';
import TimbradoMasivoTicketsActions from './tickets/components/TimbradoMasivoTicketsActions';
import TimbradoMasivoTicketsFilters from './tickets/components/TimbradoMasivoTicketsFilters';
import TimbradoMasivoTicketsItemActions from './tickets/components/TimbradoMasivoTicketsItemActions';

class TimbradoMasivoTickets extends Component {

  state = {
    selectedRowKeys: [],
    selectedRows: []
  }

  componentDidMount() {
    window.setAppTitle('Tickets comprobante');
  }

  handleOnRowSelectionChange = ({selectedRowKeys, selectedRows}) => {
    this.setState({
      selectedRowKeys,
      selectedRows
    });
  }

  handleOnRowClick = (data) => {
    this.props.history.replace({
      pathname: `/modulos/timbrado-masivo/${data.id}/info`,
      state: {
        data: {...data}
      }
    });
  }

  handleOnDateChange = (values) => {
    this.props.paginate(values);
  }

  handleOnKeywordChange = (search) => {
    this.props.paginate({ ...search });
  }

  render() {
    const { selectedRowKeys, selectedRows } = this.state;
    const { from, to, search } = this.props.pagination;

    return (
      <>
        <Row>
          <Col sm="auto" md="7" className="mb-2">
            { selectedRowKeys.length > 0 && (
              <div className="mr-3 d-inline-flex pb-2">
                <TimbradoMasivoTicketsItemActions
                  selectedRowKeys={ selectedRowKeys }
                  selectedRows={ selectedRows }
                  alignRight={ false }
                />
              </div>
            )}

            { selectedRowKeys.length === 0 && (
              <TimbradoMasivoTicketsSearch
                from={ from }
                to={ to }
                search={ search }
                onDateChange={ this.handleOnDateChange }
                onKeywordChange={ this.handleOnKeywordChange }
              />
            )}
          </Col>
          <Col sm="auto" md="5" className="text-right pb-2">
            <TimbradoMasivoTicketsActions
              from={ from }
              to={ to }
              selectedRowKeys={ selectedRowKeys }
              selectedRows={ selectedRows }
              alignRight={ false }
            />
          </Col>
        </Row>

        <TimbradoMasivoTicketsFilters />

        { Guardian.allows('facturacion.masiva.listar.archivos') && (
          <TimbradoMasivoTicketList
            onRowClick={ this.handleOnRowClick }
            selectedRowKeys={ selectedRowKeys }
            selectedRows={ selectedRows }
            onRowSelectionChange={ this.handleOnRowSelectionChange }
          />
        )}
      </>
    )
  }
}

const mapState = (store) => {
  return store.modulo.timbrado_masivo.tickets
};

const mapActions = (actions) => {
  return actions.modulo.timbrado_masivo.tickets;
};

export default connect(useStore, mapState, mapActions)(TimbradoMasivoTickets);